import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Button, Switch, Typography } from '@mui/material'
import PageLayout from 'common/Layout/Page/PageLayout'

import { ColorBoxContent, PictureWrapper } from '../../common/ui/colorBox'
import { CheckIcon } from '../../common/ui/icons'
import { splitArrayIntoRows } from '../../helpers/array'
import {
  mockAppAccesses,
  mockBundle,
  mockBundleUsage
} from '../../mock/mockData'

/**
 * Bundle Management for ...
 * @returns {React.ReactElement}
 */

export default function BundleManagement() {
  const location = useLocation()
  const [team, setTeam] = useState('')
  const [bundle, setBundle] = useState({
    _id: '',
    type: '',
    sims: 0,
    price: 0,
    data: 0,
    voice: 0,
    sms: 0
  })
  const [bundleUsage, setBundleUsage] = useState({
    status: '',
    expenditure: 0,
    activatedSims: 0,
    remainingData: 0,
    remainingVoice: 0,
    remainingSms: 0
  })
  const [appAccesses, setAppAccesses] = useState([])

  useEffect(() => {
    const appAccessRows = splitArrayIntoRows(mockAppAccesses, 2)
    setAppAccesses(appAccessRows)

    if (location.state) {
      setTeam(location.state.team)
      setBundle(location.state.bundle)
      setBundleUsage(location.state.bundleUsage)
    } else {
      setTeam('HR Department Team A')
      setBundle(mockBundle)
      setBundleUsage(mockBundleUsage)
    }
  }, [])

  return (
    <PageLayout header='Manage Bundle'>
      {(
        <Box sx={{ padding: '250px', textAlign: 'center' }}>
          <Typography variant='h4'>Coming Soon</Typography>
        </Box>
      ) || (
        <Box>
          <ColorBoxContent style={{ marginBottom: 24 }}>
            <Typography variant='h5'>{team}</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex' }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginRight: 10
                  }}
                >
                  <Typography>
                    {bundle.type}
                    <br />
                    <b>SGD${bundle.price.toFixed(2)}/mo</b>
                    <br />
                    <i>{bundleUsage.status}</i>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: 6,
                    borderLeft: '1px solid #B8C4D3'
                  }}
                >
                  <Typography>Plan Benefits</Typography>
                  {[
                    { key: 'data-benefit', benefit: `${bundle.data} GB` },
                    { key: 'voice-benefit', benefit: `${bundle.voice} min` },
                    { key: 'sms-benefit', benefit: `${bundle.sms} SMS` },
                    {
                      key: 'activatedSim-benefit',
                      benefit: `${bundleUsage.activatedSims} / ${bundle.sims} SIMs activated`
                    }
                  ].map(({ key, benefits }) => {
                    return (
                      <Box
                        key={key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <CheckIcon />
                        <Typography sx={{ margin: 1 }}>{benefits}</Typography>
                      </Box>
                    )
                  })}
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center'
                }}
              >
                <Button variant='filled' width='100%'>
                  Purchase New Add-Ons
                </Button>
                <Button variant='filled' width='100%'>
                  Add New SIMs
                </Button>
              </Box>
            </Box>
          </ColorBoxContent>

          <ColorBoxContent>
            <Typography variant='h5'>App Access</Typography>
            {appAccesses.map((accessRow, id) => (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
                key={id}
              >
                {accessRow.map((access) => (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '50%',
                      paddingRight: '36px',
                      borderBottom: `${
                        id !== appAccesses.length - 1 ? '1px solid #B8C4D3' : ''
                      }`
                    }}
                    key={access.app}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <PictureWrapper />
                      <Typography>
                        <b>{access.app}</b>
                      </Typography>
                    </Box>
                    <Switch defaultChecked={access.allowAccess} />
                  </Box>
                ))}
              </Box>
            ))}
          </ColorBoxContent>
        </Box>
      )}
    </PageLayout>
  )
}
